import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, DatePicker, Select, Space, Table, message, Tabs, Modal } from 'antd';
import dayjs from 'dayjs';
import axios from '../utils/http';
// 临时用工记录页面


// 临时用工记录页面
export default function TempWorkerUsagePage(){
  const [form] = Form.useForm();
  const [queryForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [dailyStats, setDailyStats] = useState([]);
  const [monthlyStats, setMonthlyStats] = useState([]);
  const [workerStats, setWorkerStats] = useState([]);
  const [statsLoading, setStatsLoading] = useState(false);
  const [workersOptions, setWorkersOptions] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [sumHours, setSumHours] = useState(0);
  const [deleteId, setDeleteId] = useState(null);

  // 加载临时工名单（用于多选）
  const fetchTempWorkers = async () => {
    try {
      const res = await axios.get('/temp-worker-usage/workers');
      const list = res.data.data||[];
      setWorkersOptions(list.map(n=>({value:n,label:n})));
    } catch(e){ /* ignore */ }
  };

  const fetchList = async () => {
    setLoading(true);
    try {
      const { q_worker, q_start, q_end } = queryForm.getFieldsValue();
      const params = { page, pageSize };
      if (q_worker) params.worker_name = q_worker;
      if (q_start) params.start = q_start.format('YYYY-MM-DD');
      if (q_end) params.end = q_end.format('YYYY-MM-DD');
      const res = await axios.get('/temp-worker-usage', { params });
      setData(res.data.data||[]);
      setTotal(res.data.total||0);
      setSumHours(res.data.sumHours||0);
    } catch(e){ message.error(e?.message||'加载失败'); }
    setLoading(false);
  };

  const submitEntry = async () => {
    try {
      const values = await form.validateFields();
      if (!values.worker_names || !values.worker_names.length){ message.warning('请选择姓名'); return; }
      const payload = {
        worker_names: values.worker_names,
        usage_date: values.usage_date.format('YYYY-MM-DD'),
        hours: values.hours,
        location: values.location || '',
        note: values.note || ''
      };
      const res = await axios.post('/temp-worker-usage', payload);
      message.success(`新增 ${res.data.inserted} 条记录`);
  form.resetFields(); fetchList(); fetchDailyStats(); fetchMonthlyStats(); fetchWorkerStats();
    } catch(e){ if (e?.errorFields) return; message.error(e?.message||'提交失败'); }
  };

  const fetchDailyStats = async () => {
    setStatsLoading(true);
    try {
      const { q_worker, q_start, q_end } = queryForm.getFieldsValue();
      const params={};
      if (q_worker) params.worker_name = q_worker;
      if (q_start) params.start = q_start.format('YYYY-MM-DD');
      if (q_end) params.end = q_end.format('YYYY-MM-DD');
      const res = await axios.get('/temp-worker-usage/stats/daily',{ params });
      setDailyStats(res.data.data||[]);
    } catch(e){ /* ignore */ }
    setStatsLoading(false);
  };

  const fetchMonthlyStats = async () => {
    setStatsLoading(true);
    try {
      const { q_worker, q_start, q_end } = queryForm.getFieldsValue();
      const params={};
      if (q_worker) params.worker_name = q_worker;
      if (q_start) params.startMonth = q_start.format('YYYY-MM');
      if (q_end) params.endMonth = q_end.format('YYYY-MM');
      const res = await axios.get('/temp-worker-usage/stats/monthly',{ params });
      setMonthlyStats(res.data.data||[]);
    } catch(e){ /* ignore */ }
    setStatsLoading(false);
  };

  const fetchWorkerStats = async () => {
    setStatsLoading(true);
    try {
      const { q_worker, q_start, q_end } = queryForm.getFieldsValue();
      const params={};
      if (q_worker) params.worker_name = q_worker;
      if (q_start) params.start = q_start.format('YYYY-MM-DD');
      if (q_end) params.end = q_end.format('YYYY-MM-DD');
      const res = await axios.get('/temp-worker-usage/stats/worker',{ params });
      setWorkerStats(res.data.data||[]);
    } catch(e){ /* ignore */ }
    setStatsLoading(false);
  };

  const handleExport = async () => {
    setExporting(true);
    try {
      const { q_worker, q_start, q_end } = queryForm.getFieldsValue();
      const params=[];
      if (q_worker) params.push(`worker_name=${encodeURIComponent(q_worker)}`);
      if (q_start) params.push(`start=${encodeURIComponent(q_start.format('YYYY-MM-DD'))}`);
      if (q_end) params.push(`end=${encodeURIComponent(q_end.format('YYYY-MM-DD'))}`);
      const url = `/temp-worker-usage/export${params.length? ('?'+params.join('&')):''}`;
      const res = await axios.get(url, { responseType:'blob' });
      const blob = new Blob([res.data], { type:'text/csv;charset=utf-8;' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download='temp_worker_usage.csv'; a.click(); URL.revokeObjectURL(a.href);
      message.success('导出完成');
    } catch(e){ message.error(e?.message||'导出失败'); }
    setExporting(false);
  };

  const confirmDelete = (record) => { setDeleteId(record.id); };
  const doDelete = async () => {
    if (!deleteId) return;
    try {
  await axios.delete(`/temp-worker-usage/${deleteId}`);
  message.success('删除成功');
  setDeleteId(null); fetchList(); fetchDailyStats(); fetchMonthlyStats(); fetchWorkerStats();
    } catch(e){ message.error(e?.message||'删除失败'); }
  };

  useEffect(()=>{ fetchTempWorkers(); },[]);
  useEffect(()=>{ fetchList(); },[page,pageSize]);
  useEffect(()=>{ fetchDailyStats(); fetchMonthlyStats(); fetchWorkerStats(); },[]);

  const columns = [
    { title:'日期', dataIndex:'usage_date', width:110, render:v=> (v? String(v).substring(0,10):'') },
    { title:'姓名', dataIndex:'worker_name', width:120 },
    { title:'工时', dataIndex:'hours', width:80 },
    { title:'地点', dataIndex:'location', width:160 },
    { title:'备注', dataIndex:'note', width:200, ellipsis:true },
    { title:'操作', width:80, render:(_,r)=>(<Button danger size='small' onClick={()=>confirmDelete(r)}>删除</Button>) }
  ];

  const dailyCols = [
    { title:'日期', dataIndex:'usage_date', width:110, render:v=> (v? String(v).substring(0,10):'') },
    { title:'姓名', dataIndex:'worker_name', width:120 },
    { title:'总工时', dataIndex:'sum_hours', width:100 },
    { title:'记录数', dataIndex:'entries', width:90 }
  ];
  const monthlyCols = [
    { title:'月份', dataIndex:'ym', width:110 },
    { title:'姓名', dataIndex:'worker_name', width:120 },
    { title:'总工时', dataIndex:'sum_hours', width:100 },
    { title:'记录数', dataIndex:'entries', width:90 }
  ];

  return (
    <div style={{padding:16}}>
  <h2 style={{marginBottom:16}}>临时用工记录</h2>
      <Card size='small' style={{marginBottom:16}}>
        <Form form={form} layout='inline'>
          <Form.Item name='worker_names' label='姓名' rules={[{required:true,message:'请选择姓名'}]}>
            <Select
              mode='multiple'
              options={workersOptions}
              placeholder='选择或输入姓名'
              allowClear
              showSearch
              style={{minWidth:360}}
              dropdownStyle={{minWidth:420}}
              maxTagCount='responsive'
              filterOption={(input,opt)=> (opt?.label||'').toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
          <Form.Item name='usage_date' label='日期' rules={[{required:true,message:'请选择日期'}]}>
            <DatePicker allowClear />
          </Form.Item>
          <Form.Item name='hours' label='工时' rules={[{required:true,message:'请输入工时'}]}>
            <Input type='number' min={0} step='0.5' placeholder='例如 8' style={{width:100}} />
          </Form.Item>
          <Form.Item name='location' label='地点'>
            <Input placeholder='地点' style={{width:140}} />
          </Form.Item>
          <Form.Item name='note' label='备注'>
            <Input placeholder='备注' style={{width:180}} />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type='primary' onClick={submitEntry}>新增记录</Button>
              <Button onClick={()=> form.resetFields()}>清空</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card size='small' style={{marginBottom:16}}>
        <Form form={queryForm} layout='inline'>
          <Form.Item name='q_worker' label='姓名'>
            <Input placeholder='筛选姓名' allowClear />
          </Form.Item>
          <Form.Item name='q_start' label='开始日期'>
            <DatePicker allowClear />
          </Form.Item>
          <Form.Item name='q_end' label='结束日期'>
            <DatePicker allowClear />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type='primary' onClick={()=>{ setPage(1); fetchList(); fetchDailyStats(); fetchMonthlyStats(); fetchWorkerStats(); }}>查询</Button>
              <Button onClick={()=>{ queryForm.resetFields(); setPage(1); fetchList(); fetchDailyStats(); fetchMonthlyStats(); fetchWorkerStats(); }}>重置</Button>
              <Button onClick={handleExport} loading={exporting}>导出CSV</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card size='small' style={{marginBottom:24}}>
        <div style={{marginBottom:8, fontSize:13, fontWeight:500}}>当前筛选总工时：<span style={{color:'#2563eb'}}>{sumHours}</span></div>
        <Table rowKey='id' loading={loading} dataSource={data} columns={columns} pagination={{current:page,pageSize,total,onChange:(p,ps)=>{setPage(p);setPageSize(ps);}}} size='small' scroll={{x:900}} />
      </Card>

      <Tabs items={[
        { key:'daily', label:'按日统计', children:(
          <Table rowKey={r=>r.usage_date+ r.worker_name} size='small' loading={statsLoading} dataSource={dailyStats} columns={dailyCols} pagination={false} />
        )},
        { key:'monthly', label:'按月统计', children:(
          <Table rowKey={r=>r.ym+ r.worker_name} size='small' loading={statsLoading} dataSource={monthlyStats} columns={monthlyCols} pagination={false} />
        )},
        { key:'worker', label:'按姓名统计', children:(
          <Table rowKey={r=>r.worker_name} size='small' loading={statsLoading} dataSource={workerStats} columns={[
            { title:'姓名', dataIndex:'worker_name', width:140 },
            { title:'总工时', dataIndex:'sum_hours', width:120 },
            { title:'记录数', dataIndex:'entries', width:100 }
          ]} pagination={false} />
        )}
      ]} />

      <Modal open={!!deleteId} onCancel={()=>setDeleteId(null)} onOk={doDelete} okText='确认删除' cancelText='取消'>确认删除该记录？</Modal>
    </div>
  );
}
